import TooltipComponent from './TooltipComponent';

export default TooltipComponent;
